import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ThemeService } from '@shared/services/theme.service';

@Component({
  selector: 'lgv-auth-button',
  template: `
    <button
      mat-fab
      [color]="themeService.isDarkMode() ? 'primary' : 'accent'"
      (click)="onClicked.emit()"
      style="z-index: 10;"
    >
      @if (!isLoading) {
        <mat-icon>east</mat-icon>
      }
      @if (isLoading) {
        <mat-spinner diameter="35"></mat-spinner>
      }
    </button>
  `,
  styles: [
    `
      :host {
        position: absolute;
        right: -42px;
        bottom: 70px;
      }
      button {
        width: 70px;
        height: 70px;
      }

      @media (max-width: 560px) {
        :host {
          right: 4px;
        }
      }
    `,
  ],
  standalone: false,
})
export class AuthButtonComponent {
  themeService = inject(ThemeService);

  @Input() isLoading: boolean;
  @Output() onClicked = new EventEmitter<any>();
}
